import { render, staticRenderFns } from "./InnerOffer.vue?vue&type=template&id=c8cede4a&scoped=true"
import script from "./InnerOffer.vue?vue&type=script&lang=js"
export * from "./InnerOffer.vue?vue&type=script&lang=js"
import style0 from "./InnerOffer.vue?vue&type=style&index=0&id=c8cede4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cede4a",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
